type QuizGameplayModule = typeof import('@/components/GameScreenStateMachine/QuizGameController');

let gameplayModulePromise: Promise<QuizGameplayModule> | null = null;
let gameplayModuleReadyAt: number | undefined;

function monotonicNow(): number {
  return typeof performance !== 'undefined' ? performance.now() : Date.now();
}

/** Owns one shared import so route bootstrap and React.lazy can overlap the same download. */
export function loadQuizGameplayModule(): Promise<QuizGameplayModule> {
  gameplayModulePromise ??= import('@/components/GameScreenStateMachine/QuizGameController')
    .then((module) => {
      gameplayModuleReadyAt ??= monotonicNow();
      return module;
    })
    .catch((error: unknown) => {
      gameplayModulePromise = null;
      throw error;
    });

  return gameplayModulePromise;
}

export function getQuizGameplayModuleReadyAt(): number | undefined {
  return gameplayModuleReadyAt;
}
